<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
        <!-- p-0 h-100 overflow-y-hidden -->
        <!-- <img src="~/../assets/images/left-banner.jpg" style="height: 100%;" alt=""> -->
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15">
        <grid-row class="justify-content-center h-100">
            <grid-col col="6" mobile="12">
                <grid-row class="mt-mobile-15 justify-content-center h-100 pb-30">
                    <grid-col col="12">
                        <div class="font-400 font-size-20px line-h-25 mb-20 mt-mobile-20">
                            {{ "UploadDocument" | translate }}
                        </div>
                    </grid-col>
                    <grid-col col="12">
                        <attach-box heading="ProofIncome" text="IfReceiveUploadJob" imageName="ProofIncome"></attach-box>
                    </grid-col>
                    <grid-col col="12">
                        <grid-row class="justify-content-between align-item-center mt-ipad-30">
                            <grid-col col="auto">
                                <div class="mt-15">
                                    <button class="btn-back" (click)="back()">
                                        <i class="icon-back"></i>
                                    </button>
                                </div>
                            </grid-col>
                            <grid-col col="9">
                                <button class="btn-dft" (click)="cardRequestConfrimDetails()">
                                    {{ "Next" | translate }}
                                </button>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
    </div>
</div>